import Panel from '../components/panel.tsx'
import {Button} from '../components/button.tsx'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';
import { useContext } from 'react';
import { ConfigContext } from '../config_context.ts';

import grafik from "../assets/febis_Foerdergrafik_neue_Foerderung_mitErweiterung_260720.svg";

export default function ModalInfoPeriode() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const heizung_future = useStore((state)=>state.heizung_future);
    const base_asset_url = useContext(ConfigContext).base_asset_url;
    
  return (<Panel className="panel--wide">
            <h1 id="modal-title">Heizungsförderung bis 2030</h1>
            {heizung_future == "heating_system_planned_7" &&<p>Heizung wird ausgetauscht und die neue Heizung mit einer Solarthermieanlage, einer PV-Anlage oder Wärmepumpe zur Warmwasserbereitung und/oder Raumheizung kombiniert.</p>            }
            <img className="panel_img" alt="Infografik Heizungsförderung bis 2030. Die staatliche Heizungsförderung (BEG) wird ab 2026 alle sechs Monate reduziert. Grundförderung: 30 % der förderfähigen Gesamtkosten, Klimageschwindigkeitsbonus: 16 %. Der Förderhöchstbetrag für die erste Wohneinheit sinkt schrittweise von 28.000 € (7/2026) auf 22.000 € (ab 8/2030). Für vier Einkommensgruppen sinken sowohl die Förderquote als auch der maximale Förderbetrag bis 2030. Kernaussage: Je früher der Antrag, desto höher die Förderung." src={grafik}/>
            <ModalClose label={"weiter"} onClick={()=>{
                           pop_modal();
                       }}/>
         </Panel>)
}

